import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateUserRequestBody = ApiRequestBody<typeof endpoints.users, 'post'>;

export const useCreateUserMutation = () => {
  return useMutation({
    mutationFn: async ({ ...body }: CreateUserRequestBody) => {
      const { data } = await fetchClient.POST(endpoints.users, {
        body,
      });
      return data;
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.list())();
    },
  });
};
